export default "__VITE_ASSET__uMVmZO1v__"